export const RECENT_EMPLOYEES_TYPES = {
    STARTERS: 'starters',
    LEAVERS: 'leavers',
};

export const RECENT_EMPLOYEES_TYPES_TO_LABEL_MAP = {
    [RECENT_EMPLOYEES_TYPES.STARTERS]: 'started',
    [RECENT_EMPLOYEES_TYPES.LEAVERS]: 'left',
};
